export enum EmailProviderType {
  Smtp = 0,
  Api = 1,
}

export enum EmailApiProvider {
  SendGrid = 0,
  Mailgun = 1,
  Resend = 2,
  Custom = 3,
}

export interface EmailProviderSettingsDto {
  id: string;
  name: string;
  isActive: boolean;
  providerType: EmailProviderType;
  fromEmail: string;
  fromName: string;
  replyToEmail?: string;
  smtpHost?: string;
  smtpPort: number;
  smtpUseSsl: boolean;
  smtpUsername?: string;
  smtpPassword?: string;
  smtpPasswordConfigured: boolean;
  apiProvider: EmailApiProvider;
  apiKey?: string;
  apiKeyConfigured: boolean;
  apiBaseUrl?: string;
}

export interface EmailSettingsDto {
  enabled: boolean;
  providerType: EmailProviderType;
  fromEmail: string;
  fromName: string;
  replyToEmail?: string;
  smtpHost?: string;
  smtpPort: number;
  smtpUseSsl: boolean;
  smtpUsername?: string;
  smtpPassword?: string;
  smtpPasswordConfigured: boolean;
  apiProvider: EmailApiProvider;
  apiKey?: string;
  apiKeyConfigured: boolean;
  apiBaseUrl?: string;
  dailySendLimit: number;
  totalSendLimit: number;
  providers: EmailProviderSettingsDto[];
}

export interface EmailSettingsUpdateDto {
  enabled?: boolean;
  providerType?: EmailProviderType;
  fromEmail?: string;
  fromName?: string;
  replyToEmail?: string;
  smtpHost?: string;
  smtpPort?: number;
  smtpUseSsl?: boolean;
  smtpUsername?: string;
  smtpPassword?: string;
  apiProvider?: EmailApiProvider;
  apiKey?: string;
  apiBaseUrl?: string;
  dailySendLimit?: number;
  totalSendLimit?: number;
  providers?: EmailProviderSettingsDto[];
}

export interface EmailStatsDto {
  sentToday: number;
  sentTotal: number;
  failedToday: number;
  failedTotal: number;
  dailySendLimit: number;
  totalSendLimit: number;
  remainingToday: number;
  remainingTotal: number;
  lastSentAt?: string;
}

export interface RazorpayIntegrationDto {
  enabled: boolean;
  keyId?: string;
  keySecret?: string;
  webhookSecret?: string;
  keySecretConfigured: boolean;
  webhookSecretConfigured: boolean;
}

export interface SmsIntegrationDto {
  enabled: boolean;
  provider: string;
  accountSid?: string;
  authToken?: string;
  fromNumber?: string;
  authTokenConfigured: boolean;
}

export interface MapsIntegrationDto {
  enabled: boolean;
  provider: string;
  apiKey?: string;
  apiKeyConfigured: boolean;
}

export interface AuthSettingsDto {
  frontendBaseUrl: string;
  useDemoOtp: boolean;
  demoOtpCode: string;
  otpExpiryMinutes: number;
  otpLength: number;
}

export interface IntegrationSettingsDto {
  razorpay: RazorpayIntegrationDto;
  sms: SmsIntegrationDto;
  maps: MapsIntegrationDto;
  auth: AuthSettingsDto;
}

export interface IntegrationSettingsUpdateDto {
  razorpay?: Partial<RazorpayIntegrationDto>;
  sms?: Partial<SmsIntegrationDto>;
  maps?: Partial<MapsIntegrationDto>;
  auth?: Partial<AuthSettingsDto>;
}

export interface EmailTestRequestDto {
  toEmail: string;
  subject?: string;
}
